// extracted by mini-css-extract-plugin
export default {"outerContainer":"PagedCardCollection_outerContainer__jY6Yt","listHeaderSlot":"PagedCardCollection_listHeaderSlot__KjKud","emptyContainer":"PagedCardCollection_emptyContainer__OD120"};